import colors from './colors';

export default Object.freeze({
  card: `0px 2px 10px 0px ${colors.borderShadow}03`,
});
